import request from 'superagent'
import prefix from 'superagent-prefix'
import Cookies from 'js-cookie'

const PREFIX = prefix(`${process.env.NODE_ENV === 'development' ? 'http://dev.chatchaipharmacy.com' : ''}/services/api`)
const promisify = (request) =>
  new Promise((resolve, reject) => {
    request.use(PREFIX)
      .set('Token', Cookies.get('token'))
      .end((err, res) => {
        if (err) reject(err)
        else resolve(res)
      })
  })

export default {
  // Banner
  findBanners: (payload) =>
    promisify(request.get('/banners').query(payload)),
  saveBanner: ({ bannerKey, title, link, file }) =>
    promisify(
      ((request) => file ? request.attach('file', file) : request)(
        request.post('/banners')
          .field('bannerKey', bannerKey)
          .field('title', title || '')
          .field('link', link || '')
      )
    ),
  removeBanner: (payload) =>
    promisify(request.delete(`/banners/${payload.bannerKey}`)),

  // Companies
  findCompanies: (payload) =>
    promisify(request.get('/companies').query(payload)),

  // Giveaways
  findAllGiveaways: (payload) =>
    promisify(request.get('/giveaways').query(payload)),

  // Orders
  findOrders: (payload) =>
    promisify(request.get('/orders').query(payload)),
  getCart: () =>
    promisify(request.get('/orders/cart')),
  addToCart: (payload) =>
    promisify(request.post('/orders/cart').send(payload)),
  saveCart: (payload) =>
    promisify(request.put('/orders/cart').send(payload)),
  checkout: (payload) =>
    promisify(request.post('/orders/checkout').send(payload)),
  uploadInvoice: (payload) =>
    promisify(request.post(`/orders/${payload.orderId}/invoice`).attach('file', payload.file)),
  createPackPdf: (payload) =>
    promisify(request.post(`/orders/${payload.orderId}/create-pack-pdf`)),
  createCwOrder: (payload) =>
    promisify(request.post(`/orders/${payload.orderId}/create-cw-order`)),

  findAllOrders: (payload) =>
    promisify(request.get('/orders/all').query(payload)),
  saveOrder: ({ orderId, ...rest }) =>
    promisify(request.put(`/orders/${orderId}`).send(rest)),
  reorder: (orderId) =>
    promisify(request.post(`/orders/${orderId}/reorder`)),

  // Payments
  findPayments: (payload) =>
    promisify(request.get('/payments').query(payload)),
  findAllPayments: (payload) =>
    promisify(request.get('/payments/all').query(payload)),
  savePayment: ({ paymentId, ...rest }) =>
    promisify(request.put(`/payments/${paymentId}`).send(rest)),

  // Products
  findProducts: (payload) =>
    promisify(request.get('/products').query(payload)),
  findAllProducts: (payload) =>
    promisify(request.get('/products/all').query(payload)),
  findTags: () =>
    promisify(request.get('/products/tags')),
  findRecommendations: ({ productCode }) =>
    promisify(request.get(`/products/${productCode}/recommendations`)),
  aggregateProducts: (payload) =>
    promisify(request.get('/products/aggregate').query(payload)),

  // Products - Admin
  findOneProduct: ({ productCode, ...rest }) =>
    promisify(request.get(`/products/${productCode}`).query(rest)),
  importProducts: (file) =>
    promisify(request.post('/products/import').attach('excel', file)),
  importTags: (file) =>
    promisify(request.post('/products/import/tags').attach('excel', file)),
  importConfigs: (file) =>
    promisify(request.post('/products/import/configs').attach('excel', file)),
  importStocks: (file) =>
    promisify(request.post('/products/import/stocks').attach('excel', file)),
  importBIS: (file) =>
    promisify(request.post('/products/import/back-in-stock').attach('excel', file)),
  importFD: (file) =>
    promisify(request.post('/products/import/free-delivery').attach('excel', file)),
  saveProduct: ({ productCode, ...rest }) =>
    promisify(Object.keys(rest).reduce((request, key) => {
      if (key === 'thumbnail') request.attach('thumbnail', rest[key])
      else request.field(key, rest[key])
      return request
    }, request.post(`/products/${productCode}`))),
  findProductImages: ({ productCode }) =>
    promisify(request.get(`/product-images/${productCode}`)),
  addProductImage: ({ productCode, file }) =>
    promisify(request.post(`/product-images/${productCode}`).attach('image', file)),
  removeProductImage: ({ id }) =>
    promisify(request.delete(`/product-images/${id}`)),

  // Promocode - Admin
  findAllPromocodes: (payload) =>
    promisify(request.get('/promocodes').query(payload)),
  findOnePromocode: ({ promocode, ...rest }) =>
    promisify(request.get(`/promocodes/${promocode}`).query(rest)),
  addPromocode: (payload) =>
    promisify(request.post('/promocodes').send(payload)),
  savePromocode: ({ promocode, ...rest }) =>
    promisify(request.put(`/promocodes/${promocode}`).send(rest)),
  findPromocodeSummary: (payload) =>
    promisify(request.get('/promocodes/summary').query(payload)),

  // Reward - User
  findRewards: (payload) =>
    promisify(request.get('/rewards').query(payload)),
  purchase: ({ rewardId }) =>
    promisify(request.post(`/rewards/${rewardId}`)),

  // Reward - Admin
  findAllRewards: (payload) =>
    promisify(request.get('/rewards/all').query(payload)),
  findOneReward: ({ rewardId, ...rest }) =>
    promisify(request.get(`/rewards/${rewardId}`).query(rest)),
  addReward: (payload) =>
    promisify(request.post('/rewards').send(payload)),
  saveReward: ({ rewardId, ...rest }) =>
    promisify(request.put(`/rewards/${rewardId}`).send(rest)),

  // Wishlist
  findWishlists: (payload) =>
    promisify(request.get('/wishlists').query(payload)),
  addToWishlist: ({ productCode }) =>
    promisify(request.post(`/wishlists/${productCode}`)),
  removeFromWishlist: ({ productCode }) =>
    promisify(request.delete(`/wishlists/${productCode}`)),

  // Users
  login: (payload) =>
    promisify(request.post('/users/login').send(payload)),
  logout: () =>
    promisify(request.post('/users/logout')),
  signup: (payload) =>
    promisify(request.post('/users/signup').send(payload)),
  // promisify(Object.keys(rest).reduce((request, key) => {
  //   request.field(key, rest[key]);
  //   return request;
  // }, request.post('/users/signup'))),
  verify: () =>
    promisify(request.get('/users/me')),
  findGiveaways: () =>
    promisify(request.get(`/users/giveaways`)),
  forgotPassword: (payload) =>
    promisify(request.post('/users/forgot-password').send(payload)),
  setNewPassword: (payload) =>
    promisify(request.put('/users/set-new-password').send(payload)),
  notifyPayment: ({ transferSlip, ...rest }) =>
    promisify(Object.keys(rest).reduce((request, key) => {
      request.field(key, rest[key])
      return request
    }, request.post('/payments'))
      .attach('transferSlip', transferSlip)
    ),

  // Users - Admin
  findUsers: (payload) =>
    promisify(request.get('/users').query(payload)),
  findOneUser: ({ userId, ...rest }) =>
    promisify(request.get(`/users/${userId}`).query(rest)),
  saveUser: ({ userId, ...rest }) =>
    promisify(request.put(`/users/${userId || 'me'}`).send(rest)),
  removeUser: ({ userId }) =>
    promisify(request.delete(`/users/${userId}`))
}



// WEBPACK FOOTER //
// ./src/helpers/api.js